import React, { forwardRef, ComponentProps } from 'react';

import Icon, { generateRenderedIcon, IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.92,14.26a1.75,1.75,0,0,1-1.24-.52l-4.5-4.5a1.76,1.76,0,0,1,0-2.48l4.5-4.5a1.79,1.79,0,0,1,2.48,0l4.51,4.5A1.74,1.74,0,0,1,14.18,8a1.71,1.71,0,0,1-.52,1.24l-4.5,4.5A1.75,1.75,0,0,1,7.92,14.26Zm0-11a.22.22,0,0,0-.17.08l-4.51,4.5a.27.27,0,0,0,0,.36l4.5,4.5a.21.21,0,0,0,.36,0l4.5-4.5h0a.27.27,0,0,0,0-.36L8.1,3.32A.25.25,0,0,0,7.92,3.24Z';

const draw24px =
  'M11.92,22.26a1.75,1.75,0,0,1-1.24-.52l-8.5-8.5a1.76,1.76,0,0,1,0-2.48l8.5-8.5a1.79,1.79,0,0,1,2.48,0l8.51,8.5A1.74,1.74,0,0,1,22.18,12a1.71,1.71,0,0,1-.52,1.24l-8.5,8.5A1.75,1.75,0,0,1,11.92,22.26Zm0-19a.22.22,0,0,0-.17.08l-8.51,8.5a.27.27,0,0,0,0,.36l8.5,8.5a.21.21,0,0,0,.36,0l8.5-8.5h0a.27.27,0,0,0,0-.36L12.1,3.32A.25.25,0,0,0,11.92,3.24Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ShapeDiamondIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'shapeDiamond'),
) as IconWithRender;

ShapeDiamondIcon.displayName = 'ShapeDiamondIcon';
ShapeDiamondIcon.propTypes = Icon.propTypes;
ShapeDiamondIcon.renderIcon = (props) => <ShapeDiamondIcon {...props} />;

export default ShapeDiamondIcon;
